/* @ngInject */
export default function MonitoringService($q, $sails, $log) {
  const service = this;

  service.newReport = () => sailsMethod('post', '/monitoring/report/create');
  service.joinRoom = () => sailsMethod('post', '/monitoring/join');
  service.leaveRoom = () => sailsMethod('post', '/monitoring/leave');

  // digi/rcu/cameras
  service.failed = key => sailsMethod('get', `/monitoring/status/${key}/failed`);
  service.eventInfo = event => sailsMethod('get', `/monitoring/event/${event}`);

  service.reportTtl = () => sailsMethod('get', '/monitoring/reportTtl');
  service.pendingEvents = () => sailsMethod('get', '/monitoring/events/pending');
  service.createdAt = () => sailsMethod('get', '/monitoring/createdAt');
  service.devicecloud = () => sailsMethod('get', '/monitoring/devicecloud');

  function sailsMethod(verb, url) {
    return $sails[verb](url)
      .then(res => res.body)
      .catch((err) => {
        $log.error('Could not', verb, url, err.data);
        return $q.reject(err.data);
      });
  }
}
